export const callsEnabled = process.env.REACT_APP_CALLS_ENABLED === "true";

// How long the backend keeps a call open after its host drops. Must match the backend setting.
export const hostRejoinSeconds = 120;
